module.exports = __webpack_public_path__ + "img/jl.bc53e16b.png";